import React, { useEffect, useState } from "react";

import CardBookClub from "../../molecules/card-book-club/cardBookClub";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { ReferenciaTabsContenido } from "../../../interfaces/ReferenciaTabsContenido";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import "./clubBookshelves.scss";
import { useHandleClickOutside } from "../../../utils/generalUtilities";

interface ClubBookshelvesProps extends ReferenciaTabsContenido {
  categoryName: string;
}

const ClubBookshelves = (props: ClubBookshelvesProps) => {
  const {
    referenciaPlantillaContenido,
    tituloGeneral,
    tipoComponente
  } = props.referenciaContenido[0];

  const [booksToShow, setBooksToShow] = useState<Array<any>>([]);
  const [menuBookSelected, setMenuBookSelected] = useState(-1);
  const { window, isBrowser } = useBrowserMode();

  useEffect(() => {
    const auxBooks =
      referenciaPlantillaContenido.length > 5
        ? referenciaPlantillaContenido.slice(0, 5)
        : referenciaPlantillaContenido;
    setBooksToShow(auxBooks);
  }, [referenciaPlantillaContenido]);

  useHandleClickOutside(isBrowser, () => setMenuBookSelected(-1), "m-card-book-club__icon");

  const seeMore = () => {
    const booksLeft = referenciaPlantillaContenido.length - booksToShow.length;
    if (booksLeft >= 5) {
      setBooksToShow(
        referenciaPlantillaContenido.slice(0, booksToShow.length + 5)
      );
    } else {
      setBooksToShow(referenciaPlantillaContenido);
    }
    const cardsContainer: any = document.querySelector(".o-club-detail");
    const elementToScroll: any = document.querySelectorAll(".m-card-book-club")[
      booksToShow.length - 1
    ];
    const cardHeight = elementToScroll.offsetHeight;
    window.scroll({
      top: cardsContainer?.offsetTop + elementToScroll.offsetTop + cardHeight,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <section className="o-club-bookshelves">
      <h2 className="o-club-bookshelves__title">{tituloGeneral}</h2>
      <div className="o-club-bookshelves__books-section">
        <div className="o-club-bookshelves__books-section__titles">
          <p>Título</p>
          {
            tipoComponente === "audio" ? "" : <p>Sesión y Fecha</p>
          }
          <p>Acciones</p>
        </div>
        <div className="o-club-bookshelves__books-section__books">
          {booksToShow &&
            booksToShow.map((book, index) => (
              <CardBookClub
                {...book}
                key={index}
                selected={index === menuBookSelected}
                setSelected={setMenuBookSelected}
                index={index}
                gtmMark={`gtm${normalizeTwoWords(
                  props.categoryName
                )}${normalizeTwoWords(props.nombreTab)}`}
                cardAudio={book.cardAudio || false}
                audio={book?.audioPrincipal?.file?.url || null}
              />
            ))}
        </div>
      </div>
      {referenciaPlantillaContenido.length > booksToShow.length && (
        <div className="o-club-bookshelves__see-more">
          <button
            className="o-club-bookshelves__see-more__cta"
            onClick={() => seeMore()}
          >
            Ver más
          </button>
        </div>
      )}
    </section>
  );
};

export default ClubBookshelves;
